import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import StudioLayout from "./components/studio/StudioLayout";
import AuthRedirecter from "./components/studio/auth/authRedirecter";
import { Toaster } from "./components/ui/toaster";
import "./index.css";
import NotFound from "./pages/404";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import NoAccess from "./pages/NoAccess";
import Portfolio from "./pages/Portfolio";
import PublicFolder from "./pages/public/PublicFolder";
import PublicNote from "./pages/public/PublicNote";
import PublicRecipe from "./pages/public/PublicRecipe";
import Birthday from "./pages/studio/Birthday";
import Clock from "./pages/studio/Clock";
import Cookbook from "./pages/studio/Cookbook/Cookbook";
import EditRecipe from "./pages/studio/Cookbook/EditRecipe";
import NewRecipe from "./pages/studio/Cookbook/NewRecipe";
import Recipe from "./pages/studio/Cookbook/Recipe";
import Daily from "./pages/studio/Daily";
import Expenses from "./pages/studio/Expenses";
import Inbox from "./pages/studio/Inbox";
import ArchivedInbox from "./pages/studio/Inbox/ArchivedInbox";
import InboxItem from "./pages/studio/Inbox/InboxItem";
import Login from "./pages/studio/Login";
import MarkdownEditor from "./pages/studio/MarkdownEditor";
import EditNote from "./pages/studio/Notes/EditNote";
import Notes from "./pages/studio/Notes/Home";
import Note from "./pages/studio/Notes/Note";
import Profile from "./pages/studio/Profile";
import Settings from "./pages/studio/Settings";
import Hermes from "./pages/portfolios/Hermes";
import Recruitment from "./pages/portfolios/Recruitment";
import Registrate from "./pages/studio/Registrate";
import StudioBlog from "./pages/studio/Blog";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import EditBlogPost from "./pages/studio/Blog/EditBlog";
import Kanban from "./pages/studio/Kanban";
import KanbanBoard from "./pages/studio/Kanban/Board";
import ExpenseList from "./pages/studio/Expenses/List";
import PublicExpenseList from "./pages/public/PublicExpenses";
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/",
                element: <Home />
            },
            {
                path: "/about",
                element: <About />
            },
            {
                path: "/portfolio",
                element: <Portfolio />
            },
            {
                path: "/portfolio/hermes",
                element: <Hermes />
            },
            {
                path: "/portfolio/recruitment",
                element: <Recruitment />
            },
            {
                path: "/blog",
                element: <Blog />
            },
            {
                path: "/blog/:slug/:id",
                element: <BlogPost />
            },
            {
                path: "/contact",
                element: <Contact />
            }
        ]
    },
    {
        path: "/",
        children: [
            {
                path: "/recipe/:slug/:id",
                element: <PublicRecipe />
            },
            {
                path: "/note/:slug/:id",
                element: <PublicNote />
            },
            {
                path: "/folder/:slug/:id",
                element: <PublicFolder />
            },
            {
                path: "/expenses/:slug/:id",
                element: <PublicExpenseList />
            },
            {
                path: "/no-access",
                element: <NoAccess />
            }
        ]
    },
    {
        path: "/studio",
        element: <AuthRedirecter />,
        children: [
            {
                path: "login",
                element: <Login />
            },
            {
                path: "registrate",
                element: <Registrate />
            },
            {
                element: <StudioLayout />,
                children: [
                    {
                        path: "",
                        element: <Profile />
                    },
                    {
                        path: "daily",
                        element: <Daily />
                    },
                    {
                        path: "settings",
                        element: <Settings />
                    },
                    {
                        path: "clock",
                        element: <Clock />
                    },
                    {
                        path: "expenses/overview",
                        element: <Expenses />
                    },
                    {
                        path: "expenses/lists",
                        element: <Expenses />
                    },
                    {
                        path: "expenses/list/:id",
                        element: <ExpenseList />
                    },
                    {
                        path: "notes",
                        element: <Notes />
                    },
                    {
                        path: "notes/:folder",
                        element: <Notes />
                    },
                    {
                        path: "notes/note/:note",
                        element: <Note />
                    },
                    {
                        path: "notes/note/:note/edit",
                        element: <EditNote />
                    },
                    {
                        path: "kanban",
                        element: <Kanban />
                    },
                    {
                        path: "kanban/board/:id",
                        element: <KanbanBoard />
                    },
                    {
                        path: "cookbook",
                        element: <Cookbook />
                    },
                    {
                        path: "cookbook/new",
                        element: <NewRecipe />
                    },
                    {
                        path: "cookbook/recipe/:id",
                        element: <Recipe />
                    },
                    {
                        path: "cookbook/recipe/:id/edit",
                        element: <EditRecipe />
                    },
                    {
                        path: "birthday",
                        element: <Birthday />
                    },
                    {
                        path: "markdown",
                        element: <MarkdownEditor />
                    },
                    {
                        path: "blog",
                        element: <StudioBlog />
                    },
                    {
                        path: "blog/:id/edit",
                        element: <EditBlogPost />
                    },
                    {
                        path: "inbox",
                        element: <Inbox />
                    },
                    {
                        path: "archive/inbox",
                        element: <ArchivedInbox />
                    },
                    {
                        path: "inbox/:id",
                        element: <InboxItem />
                    },
                    {
                        path: "archive/inbox/:id",
                        element: <InboxItem />
                    }
                ]
            }
        ]
    },

    {
        path: "*",
        element: <NotFound />
    }
]);

root.render(
    <>
        <RouterProvider router={router} />
        <Toaster />
    </>
);
